export default __webpack_public_path__ + "static/Cafe_Header-9f71701ae9345a1ff27694074dbac193.mp4";